import { Box } from "../../box";
import { forwardRef } from "react";
import { cssModule, mergeProps, slot } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "img";
export function InnerImage({
  as = DefaultElement,
  forwardedRef,
  shape = "straight",
  ...rest
}) {
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-image", shape),
      ref: forwardedRef
    })
  });
}
InnerImage.defaultElement = DefaultElement;
export const Image = slot("image", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerImage, { ...props,
  forwardedRef: ref
})));